export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[700px] mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-8">有任何问题或建议，欢迎随时与我们沟通</p>

        <div className="rounded-2xl bg-background-50 border border-background-200/70 p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
            <div className="text-center p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <p className="text-sm font-medium text-foreground-900 mb-1">商务合作</p>
              <p className="text-xs text-foreground-500">bd@aidou.tv</p>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-file-copy-line text-accent-600 text-lg"></i>
              </div>
              <p className="text-sm font-medium text-foreground-900 mb-1">内容投稿</p>
              <p className="text-xs text-foreground-500">submit@aidou.tv</p>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-secondary-200 flex items-center justify-center">
                <i className="ri-question-answer-line text-secondary-600 text-lg"></i>
              </div>
              <p className="text-sm font-medium text-foreground-900 mb-1">用户反馈</p>
              <p className="text-xs text-foreground-500">feedback@aidou.tv</p>
            </div>
          </div>

          <p className="text-sm text-foreground-500 leading-relaxed">
            爱豆影视持续优化观影体验，欢迎通过以上渠道与我们联系。无论是资源建议、技术问题还是合作意向，我们都会在24小时内回复。
          </p>
        </div>
      </div>
    </section>
  );
}